/**
 * 个人
 */
<template>
    <div class="form">
      <div class="avatar">
        <img :src="ruleForm.headPic" v-if="ruleForm.headPic">
        <img src="../../assets/img/default.png" v-else>
      </div>
      <div class="upload">
        <el-upload
          class="upload-demo"
          :action="uploadApi"
          name='image'
          :show-file-list="false"
          :on-success="handSuccess">
          <el-button style="background-color: #ff821c" type="warning" size="small" icon="el-icon-upload">上传头像</el-button>
        </el-upload>
      </div>
      <div class="e-form">
        <p class="key"><span class="prop">*</span>昵称：</p>
        <el-input v-model="ruleForm.username" placeholder="请输入昵称" style="font-size: 12px;"></el-input>
        <div class="phone">
          <p class="key"><span class="prop">*</span>手机号：</p>
          <p class="tele">{{userInfo.mobile.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')}}</p>
          <p class="modify" @click="onManage">点击修改</p>
        </div>
        <div style="display: flex;align-items: center;justify-content: space-between;">
          <el-button style="background-color: #ff821c" size="medium" type="warning" :loading="loading" @click="submitForm">保存</el-button>
          <el-button class="buttons" size="medium">取消</el-button>
        </div>
      </div>
    </div>
</template>

<script>
import {userInfo, editUserInfo } from '../../api/userMG'
export default {
  data() {
    return {
      type:1,
      ruleForm: {
        headPic:'',
        username: '',
      },
      loading:false,
      mobile:''
    }
  },
  props: {
    userInfo: {
      type: Object,
      default: () => ({}),
    }
  },
  computed: {
    uploadApi() {
      return this.$store.getters.uploadApi;
    }
	},
  /**
   * 创建完毕
   */
  created() {
    // this.getUserInfo()
    console.log("个人资料",this.userInfo)
    this.ruleForm.headPic = this.userInfo.headPic;
    this.ruleForm.username = this.userInfo.username;
  },
  computed: {
    url() {
      return this.$store.getters.url;
    }
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    async getUserInfo(){
      await userInfo().then(res => {
          console.log('个人用户信息',res);
           // this.userInfo = res.data;
          this.ruleForm.headPic = this.userInfo.headPic;
          this.ruleForm.username = this.userInfo.username;
          this.mobile = this.userInfo.mobile;
      })
      .catch(err => {
        // this.$message.error('请求失败，请稍后再试！')
      })
    },
    onButton(e){
      this.type = e
    },
    
    // 编辑、增加页面保存方法
    submitForm() {
      if(!this.ruleForm.headPic){
        this.$message({
          message: '请上传头像',
          type: 'warning',
          offset:100
        });
        return
      }
      if(!this.ruleForm.username){
        this.$message({
          message: '请输入昵称',
          type: 'warning',
          offset:100
        });
        return
      }
      this.loading = true
      editUserInfo(this.ruleForm).then(res => {
        this.loading = false
        console.log("保存用户信息",res.code)
        if(res.code == 0){
         
          localStorage.setItem('headPic',this.ruleForm.headPic)
          this.$emit('getUserInfo');
          this.$message({
            message: '保存成功！',
            type: 'success',
            offset:100
          });
        }
      })
      .catch(err => {
        this.loading = false;
        this.$message({
          message: '保存失败，请稍后再试！',
          type: 'error',
          offset:100
        });
      })
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handSuccess(response, file, fileList) {
      console.log(file.response.data);
      this.ruleForm.headPic = file.response.data
    },
    onManage(){
      this.$router.push({path:'/manage/manage'})
    }
  }
}
</script>

<style scoped>
  .form{
    margin:60px auto 0;
    width: 55%;
  }
  .form .avatar{
    margin-bottom: 10px;
    text-align: center;
  }
  .form .avatar img{
    width: 80px;
    height: 80px;
    border-radius: 50%;
  }
  .upload{
    text-align: center;
    margin-bottom: 40px;
  }
  .el-button--small{
    padding: 6px 18px;
  }
  .e-form .key{
    font-size: 13px;
    color: #666;
    margin-bottom: 6px;
  }
  .e-form .prop{
    color: #ff821c;
    margin-right: 2px;
  }
  .phone{
    display: flex;
    align-content: center;
    margin-top: 20px;
    margin-bottom: 40px;
  }
  .tele{
    font-size: 12px;
    font-weight: 600;
    color: black;
    line-height: 19px;
    margin-left: 4px;
    margin-right: 30px;
    
  }
  .modify{
    color: #ff821c;
    font-size: 12px;
    font-weight: 600;
    border-bottom: 1px solid #ff821c;
    cursor: pointer;
  }
  .e-form .el-button--medium{
    padding: 14px 0px;
    width: 48%;
  }
  .el-form-item /deep/ .el-button--primary{
    background-color: #ff821c;
  }
</style>

 
 


// WEBPACK FOOTER //
// src/components/data/personal.vue